export default __webpack_public_path__ + "static/media/FirstLeftBottomEllipse.9a54a487.svg";